<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>会员编号：</label>
                <el-input v-model="search_Obj.f_member_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>姓名：</label>
                <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>手机号：</label>
                <el-input v-model="search_Obj.f_cellphone" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>商品名称：</label>
                <el-input v-model="search_Obj.f_goods_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="member_code" label="会员编号" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="name" label="姓名" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="cellphone" label="手机号" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" sortable="custom"></el-table-column>
                <el-table-column prop="commission_tuan" label="佣金比例(%)" sortable="custom" width="130"></el-table-column>
                <el-table-column prop="start_time" label="开始时间" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="end_time" label="结束时间" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom" width="100">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "act_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="800px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="800px"
            :id="model_id"
            title="查看开团情况"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'promotionGoodsList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '开团',
            menu_id: 7610,
            list_url: "/api/admin/promotiongoods/list",
            search_Obj: {
                f_member_code: '',
                f_name: '',
                f_cellphone: '',
                f_goods_name: '',
            },
            del_Obj:{
                url:'/api/admin/promotiongoods/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['act_state'],
        };
    },
    methods: {}
};
</script>